import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AmPmFormatPipe } from './AmPmFormatPipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AmPmFormatPipe
    ],
    exports: [
        AmPmFormatPipe 
    ]
})
export class SharedPipesModule { }
